import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { FormHubspotComponent } from 'src/app/shared/components/form-hubspot/form-hubspot.component';
import { ModalGeneralComponent } from 'src/app/shared/components/modal-general/modal-general.component';
import { FormContactoComponent } from 'src/app/shared/widgets/form-contacto/form-contacto.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aranceles-cursos',
  templateUrl: './aranceles-cursos.component.html',
  styleUrls: ['./aranceles-cursos.component.scss']
})
export class ArancelesCursosComponent implements OnInit {

  @Input()
  datos: any;
  isDesktop = window.innerWidth > 767;
  @ViewChild('imgContainer') imgContainer!: ElementRef;
  @ViewChild('containerDerecho') containerDer!: ElementRef;
  @Input()
  cuotas: any;
  apiUrl = ""
  venue = ""
  carrer = ""
  constructor(public dialog: MatDialog, private aRouter: ActivatedRoute) {
    this.aRouter.params.forEach((params: Params) => {
      this.venue = this.aRouter.snapshot.params['venue']
      this.carrer = this.aRouter.snapshot.params['carrer']
    });
    this.apiUrl = environment.apiUrl;
  }

  ngOnInit(): void {
  }

  private bloqueo = 0;

  ngAfterViewChecked(): void {
    if (this.bloqueo < 2) {
      setTimeout(() => {
        //this.checkHeight();
      }, 0);
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isDesktop = (event.target as Window).innerWidth > 767;
    this.checkHeight();

  }
  checkHeight() {
    this.isDesktop = window.innerWidth > 768;

    if (this.containerDer != null && this.imgContainer != null) {

      if (this.isDesktop) {
        let alto = this.containerDer.nativeElement.offsetHeight;
        let altoAumentado = alto * 1.1;
        this.imgContainer.nativeElement.style.minHeight = `${(altoAumentado)}px`;
      } else {
        this.imgContainer.nativeElement.style.minHeight = `100%`;
      }
      this.bloqueo++;
    }


  }
  openModalConsulta() {
    if (this.datos.form_hubspot) {
      const data = { formId: '8d3b3305-d944-466c-95a8-df7e2235b758', portalId: '23647426' };
      this.dialog.open(FormHubspotComponent, { data });
    } else {
      localStorage.setItem('curso', this.carrer)
      let dialogRef = this.dialog.open(FormContactoComponent, { panelClass: 'custom-dialog-container' });
      let instance = dialogRef.componentInstance;
      this.venue = this.venue
      this.carrer = this.carrer
      const sub = dialogRef.componentInstance.closeModal.subscribe(() => {
        this.dialog.closeAll();
      });
    }
  }


  externalLink() {
    if (this.datos.button_signUp) {
      window.open(this.datos.button_signUp, '_blank');
    }
  }
  openModal(item: any) {
    this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: item.body, title: item.title } });
  }
  openLink(item: any) {
    window.open(item.body, '_blank');
  }


  abrirWhatsApp(url: string): void {
    window.open(url, '_blank');
  }
}
